// src/components/ProjectGallery.tsx
import React, { useState, useMemo, useRef, useLayoutEffect } from "react";

import projectImage from "../../assets/building.png";
import { PROJECTS } from "../../data/constants";

// ——— NotchButton ———
const NotchButton: React.FC<{
  label: string;
  isActive: boolean;
  onClick: () => void;
}> = ({ label, isActive, onClick }) => {
  const textRef = useRef<SVGTextElement>(null);
  const [boxW, setBoxW] = useState(0);

  // constants for height and notch depth
  const H =40;
  const notch = 10;
  const paddingX = 15;  // px of horizontal padding

  // measure text width once it's rendered
  useLayoutEffect(() => {
    if (textRef.current) {
      const bw = textRef.current.getBBox().width + paddingX * 2;
      setBoxW(Math.ceil(bw));
    }
  }, [label]);

  // polygon points for a bottom-right cut
  const points =
    boxW > 0
      ? [
          `0,0`,                     // top-left
          `${boxW},0`,               // top-right
          `${boxW},${H - notch}`,    // down to notch start on right
          `${boxW - notch},${H}`,    // left to notch end on bottom
          `0,${H}`,                  // bottom-left
        ].join(" ")
      : "";

  return (
    <svg
      onClick={onClick}
      width={boxW || undefined}
      height={H}
      viewBox={`0 0 ${boxW || 1} ${H}`}
      style={{ overflow: "visible", cursor: "pointer", margin: "0.25rem" }}
      className={isActive ? "notch-btn active" : "notch-btn"}
    >
      {boxW > 0 && (
        <polygon
          points={points}
          fill="transparent"
          stroke="#0C4A6E"
          strokeWidth="2"
        />
      )}
      <text
        ref={textRef}
        x={(boxW || 0) / 2}
        y={26}
        textAnchor="middle"
        fontFamily="sans-serif"
        fontSize="16"
        fill="#0C4A6E"
        pointerEvents="none"
        className="font-inter text-[16px] "
      >
        {label}
      </text>
      <style>{`
        .notch-btn:hover polygon,
        .notch-btn.active polygon {
          fill: #0C4A6E;
        }
        .notch-btn:hover text,
        .notch-btn.active text {
          fill: #ffffff;
        }
      `}</style>
    </svg>
  );
};

const categories = [
  "All",
  "Commercial",
  "Residential",
  "Government",
  "Healthcare",
  "Education",
];



const ProjectGalleryMobile: React.FC = () => {
  const [active, setActive] = useState("All");
  const filtered = useMemo(
    () =>
      active === "All"
        ? PROJECTS
        : PROJECTS.filter((p) => p.category === active),
    [active]
  );
  
       
  return (
    <section className="bg-[#F5F7FA] px-6 pb-[60px] md:px-24">
      <h2 className="font-utility text-center text-[24px] md:text-[54px] font-[500] text-[#0A1E2D] leading-snug mx-auto">
        Discover Our Exceptional
        Glass Solutions,
        Tailored To Every Industry. 
      </h2>

      {/* Tabs */}
      <div className="flex flex-wrap justify-center gap-[16px] mt-[32px]">
        {categories.map((cat) => (
          <NotchButton
            key={cat}
            label={cat}
            isActive={active === cat}
            onClick={() => setActive(cat)}
          />
        ))}
      </div>

      {/* Projects Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 mt-14">
        {filtered.map((project) => {
         
          return (
            <div
             
              className="block group"
            >
              <img
                src={project.image ?? projectImage}
                alt={project.name}
                className="md:w-[424px] md:h-[638px] object-cover group-hover:opacity-90 transition"
              />
              <h4 className="font-sans mt-4 text-[24px] font-medium text-[#0A1E2D]">
                {project.name}
              </h4>
              <p className="font-sans text-[24px] font-normal text-[#506270]">
                {project.location}
              </p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ProjectGalleryMobile;
